// This is to prepare libraries and environment.
// Require this module on top of the application.
"use strict";

import "core-js/stable";
import "regenerator-runtime/runtime";

import 'jquery';
import 'async';
import 'lodash';
import 'url';
import 'querystring';

// Bootstrap hacks.
window.jQuery = global.jQuery = $;
import 'bootstrap-sass';
import 'eonasdan-bootstrap-datetimepicker';

// Configure numeral
import numeral from 'numeral'
numeral.defaultFormat = '0,0';